<template>
    <div class="relative">
        <CCard>
            <CCardHeader>
                <p>Текст пользовательского соглашения</p>
            </CCardHeader>
            <CCardBody v-if="model">
                <CInput
                    label="Версия соглашения:"
                    v-model="model.settings.version"
                />
                <CInput
                    label="Дата размещения:"
                    v-model="model.settings.date_of_placement"
                />
                <CInput
                    label="Дата утверждения:"
                    v-model="model.settings.date_of_approval"
                />
                <CInput
                    label="Дата начала действия:"
                    v-model="model.settings.date_of_commencement_of_action"
                />
                <CTextarea
                    label="Пользовательское соглашение:"
                    v-model="model.settings.text"
                    :rows="20"
                />
                <CTextarea
                    label="Что нового:"
                    v-model="model.settings.text_new"
                    :rows="20"
                />
            </CCardBody>

            <CCardFooter>
                <CButton
                    class="ml-auto"
                    color="primary"
                    @click="submit">
                    Сохранить
                </CButton>
            </CCardFooter>
        </CCard>

        <CElementCover
            v-if="isPending"
            :opacity="0.8"
        >
            <div class="flex items-center">
                <CSpinner size="sm" />
                <p class="ml-2 text-xl">Сохранение... </p>
            </div>
        </CElementCover>
    </div>
</template>

<script>
    import { cilSettings } from '@coreui/icons';

    export default {
        icons: {
            cilSettings
        },

        data: () => ({
            isPending: false,
            model: {
                id: 0,
                page: 'agreement',
                settings: {
                    version: 0,
                    text: '',
                    text_new: '',
                    date_of_placement: '',
                    date_of_approval: '',
                    date_of_commencement_of_action: '',
                }
            }
        }),

        async created() {
            await this.fetchEntity();
        },

        methods: {
            pictureUrl(picture) {
                return picture ? (process.env.VUE_APP_STATIC_BASE_URL + '/' + picture) : '';
            },

            async fetchEntity() {
                try {
                    this.isPending = true
                    const { data } = await this.axios.get('/page-settings/agreement');
                    if (data && data.settings) {
                        this.model = data;
                    }
                } catch (error) {
                    console.log(error);
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },

            async submit() {
                try {
                    this.isPending = true
                    const { id, ...data } = this.model;
                    if (id) {
                        await this.axios.put(`/page-settings/${id}`, data)
                    } else {
                        await this.axios.post('/page-settings', data)
                    }
                } finally {
                    setTimeout(() => {
                        this.isPending = false
                    }, 500)
                }
            },
        }
    }
</script>